import React from 'react';
import { array, bool, object, string, oneOfType, number } from 'prop-types';
import { map, isEmpty } from 'ramda';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Divider from '@material-ui/core/Divider';
import Grid from '@material-ui/core/Grid';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import DoneIcon from '@material-ui/icons/Done';
import { styled } from '@material-ui/core';

import Image from '../Image/Image';
import Button from '../Button/Button';
import Title from '../Title/Title';
import Typography from '../Typography/Typography';

const styles = {
  content: {
    display: 'flex',
    flexDirection: 'column',
  },
  text: {
    fontSize: '10px',
    marginBottom: '2px',
  },
};

const PremiumGarageGrid = styled(Grid)({
  display: 'flex',
  '& h6': {
    marginTop: '1.5%',
  },
  '& svg.MuiSvgIcon-root': {
    color: 'rgb(76, 175, 80)',
    marginRight: '2%',
  },
});

const Modal = ({
  id,
  testId,
  actions = [],
  checkboxes = [],
  content,
  contentAlert,
  open = false,
  title,
  name = 'modal',
  titleValues,
  contentValues,
  isNpsModal = false,
  isHideBackDrop = false,
  list,
  customStyle = {},
}) => (
  <>
    {!isNpsModal ? (
      <Dialog
        id={id}
        data-testid={testId}
        style={{ maxHeight: '95%' }}
        PaperProps={{
          style: { padding: '8px 16px 16px 16px' },
        }}
        name={name}
        open={open}
        hideBackdrop={isHideBackDrop}
      >
        <DialogTitle className={customStyle.dialogTitleContainer}>
          <Title content={title.content} style={customStyle.dialogTitle} src={title.src} size={42} icon={title.icon} values={titleValues} />
          <Divider
            style={
              name === 'contextGarageNetwork' || list ? { width: '50%', backgroundColor: '#193F9C ', margin: 'auto' } : { width: '100%' }
            }
          />
          {name === 'contextGarageNetwork' && (
            <Title content={title.content_chooseAddress} style={customStyle.content_chooseAddress_style} />
          )}
          {list && list.title && (
            <Typography
              content={list.title}
              style={{ fontWeight: 600, fontSize: 15, display: 'block', marginTop: '10px' }}
              color="textPrimary"
              variant="p"
            />
          )}
        </DialogTitle>
        {list && list.content && (
          <ul style={{ marginTop: '-8px' }}>
            {list.content.map((listItem, index) => (
              <li key={index}>{listItem}</li>
            ))}
          </ul>
        )}
        {name === 'contextGarageNetwork' ? (
          <DialogContent style={styles.content}>
            <Title content={title.content_recommended} modalName={name} style={customStyle.dialogContentTitle} />
            <Typography content={content.desc_recommended} align="left" style={styles.text} />
            <PremiumGarageGrid alignItems="center">
              <Typography content={title.content_premium} variant="h6" style={{ fontSize: '14px' }} />
              <Image name={title.src_premium} height={42} width={42} />
            </PremiumGarageGrid>
            <PremiumGarageGrid>
              <DoneIcon style={styles.text} />
              <Typography content={content.premium_advantages} align="left" style={styles.text} />
            </PremiumGarageGrid>
            <PremiumGarageGrid>
              <DoneIcon style={styles.text} />
              <Typography content={content.premium_service} align="left" style={styles.text} />
            </PremiumGarageGrid>
            <PremiumGarageGrid>
              <DoneIcon style={styles.text} />
              <Typography content={content.premium_availability} align="left" style={styles.text} />
            </PremiumGarageGrid>
          </DialogContent>
        ) : (
          <DialogContent style={styles.content}>
            {isEmpty(checkboxes) ? (
              <>
                <Typography style={{ color: '#ff0000' }} content={contentAlert} />
                <Typography content={content} values={contentValues} style={customStyle} />
              </>
            ) : (
              map(
                ({ name: checkboxName, checked, onChange, label, ...rest }) => (
                  <FormControlLabel
                    key={checkboxName}
                    control={<Checkbox checked={checked} name={checkboxName} onChange={e => onChange(e.target.checked)} {...rest} />}
                    label={label}
                  />
                ),
                checkboxes
              )
            )}
          </DialogContent>
        )}
        <DialogActions>
          <Grid container>
            {map(
              action => (
                <Button key={action.content.id} style={{ marginTop: 12 }} {...action} />
              ),
              actions
            )}
          </Grid>
        </DialogActions>
      </Dialog>
    ) : (
      <Dialog
        id={id}
        data-testid={testId}
        PaperProps={{
          style: {
            position: 'absolute',
            bottom: 0,
            backgroundColor: '#F5F5F5',
            boxShadow: 'none',
            width: '100%',
            marginBottom: '1%',
            textAlign: 'left',
          },
        }}
        name={name}
        open={open}
      >
        <DialogContent style={styles.content}>
          <Typography style={{ color: 'black', textAlign: 'left', fontSize: '20px' }} content={title.content} values={titleValues} />
          <Typography style={{ textAlign: 'left' }} content={content} values={contentValues} />
        </DialogContent>
        <DialogActions>
          <Grid container style={{ display: 'flex', justifyContent: 'space-between' }}>
            {map(
              action => (
                <Button key={action.content.id} style={{ width: '48%' }} {...action} />
              ),
              actions
            )}
          </Grid>
        </DialogActions>
      </Dialog>
    )}
  </>
);

Modal.propTypes = {
  id: string,
  testId: string,
  actions: array,
  checkboxes: array,
  content: oneOfType([number, object, string]),
  contentAlert: oneOfType([number, object, string]),
  open: bool,
  title: object,
  name: string,
  titleValues: object,
  contentValues: object,
  isNpsModal: bool,
  isHideBackDrop: bool,
  list: array,
  customStyle: object,
};

export default Modal;
